import React from "react";
import { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    };

    const animateOnScroll = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;

          // Remove any existing animation classes
          element.classList.remove(
            'fadeInUp', 'fadeInLeft', 'fadeInRight',
            'zoomIn', 'slideInUp', 'animated'
          );

          // Add base animation class
          element.classList.add('animated');

          // Add specific animation based on data attribute or default
          const animationType = element.dataset.animation || 'fadeInUp';
          const delay = element.dataset.delay || '0';

          element.style.animationDelay = `${delay}ms`;
          element.classList.add(animationType);

          // Only animate once
          observer.unobserve(element);
        }
      });
    };

    const observer = new IntersectionObserver(animateOnScroll, observerOptions);

    // Observe all elements with animation classes
    document.querySelectorAll('.animated-section, [data-animation]').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>
        {`
        /* Base Animation Styles */
        .animated {
          animation-duration: 1s;
          animation-fill-mode: both;
          opacity: 0;
        }
        
        /* Animation Delays */
        .delay-100 { animation-delay: 100ms; }
        .delay-200 { animation-delay: 200ms; }
        .delay-300 { animation-delay: 300ms; }
        .delay-400 { animation-delay: 400ms; }
        .delay-500 { animation-delay: 500ms; }
        
        /* Keyframe Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translate3d(0, 40px, 0);
          }
          to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }
        }
        
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translate3d(-40px, 0, 0);
          }
          to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }
        }
        
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translate3d(40px, 0, 0);
          }
          to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }
        }
        
        @keyframes zoomIn {
          from {
            opacity: 0;
            transform: scale3d(0.8, 0.8, 0.8);
          }
          to {
            opacity: 1;
            transform: scale3d(1, 1, 1);
          }
        }
        
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translate3d(0, 100px, 0);
          }
          to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }
        }
        
        /* Animation Classes */
        .fadeInUp {
          animation-name: fadeInUp;
        }
        
        .fadeInLeft {
          animation-name: fadeInLeft;
        }
        
        .fadeInRight {
          animation-name: fadeInRight;
        }
        
        .zoomIn {
          animation-name: zoomIn;
        }
        
        .slideInUp {
          animation-name: slideInUp;
        }
        
        /* Special animations for specific sections */
        .location-block-one {
          transition: all 0.5s ease;
        }
        
        .location-block-one:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.1);
        }
        `}
      </style>

      <section className="page-title animated-section" data-animation="fadeInUp">
        <div className="bg-layer" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/background/page-title.jpg)` }}></div>
        <div className="auto-container">
          <div className="content-box animated-section" data-animation="zoomIn">
            <h1>Contact Us</h1>
          </div>
        </div>
      </section>

      <section className="contact-section animated-section" data-animation="fadeInUp">
        <div className="shape" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/shape/shape-30.png)` }}></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="row clearfix">
              <div className="col-lg-5 col-md-12 col-sm-12 inner-column animated-section" data-animation="fadeInLeft">
                <div className="inner-box" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/background/contact-1.jpg)` }}>
                  <div className="inner">
                    <div className="single-item animated-section" data-animation="fadeInUp" data-delay="100">
                      <div className="icon-box"><img src={`${process.env.PUBLIC_URL}/assets/images/icons/icon-53.png`} alt="" /></div>
                      <h4>We are Here</h4>
                      <p>
                        <strong>Asysta India Private Limited</strong><br />
                        114 Street-5, Shastri Colony, Sonipat, Haryana
                      </p>
                    </div>
                    <div className="single-item animated-section" data-animation="fadeInUp" data-delay="200">
                      <div className="icon-box"><img src={`${process.env.PUBLIC_URL}/assets/images/icons/icon-28.png`} alt="" /></div>
                      <h4>Quick Contact</h4>
                      <p><a href="tel:04488812345678">044 888 12 345 [or] 678</a><br /><a href="mailto:support@example.com">support@example.com</a></p>
                    </div>
                    <div className="single-item animated-section" data-animation="fadeInUp" data-delay="300">
                      <div className="icon-box"><img src={`${process.env.PUBLIC_URL}/assets/images/icons/icon-31.png`} alt="" /></div>
                      <h4>Off.Hours</h4>
                      <p>Monday - Satday: 9am to 6.30pm <br />Sunday: Holiday</p>
                    </div>
                  </div>
                  <ul className="social-links clearfix animated-section" data-animation="fadeInUp" data-delay="400">
                    <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                    <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                    <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-7 col-md-12 col-sm-12 form-column animated-section" data-animation="fadeInRight">
                <div className="form-inner">
                  <div className="sec-title light animated-section" data-animation="fadeInUp">
                    <h2>Send your enquiry</h2>
                    <p>Complete the enquiry form & we will be in touch as soon as possible.</p>
                  </div>
                  <form method="post" action="https://st.ourhtmldemo.com/new/Udrive/sendemail.php" id="contact-form">
                    <div className="row clearfix">
                      <div className="col-lg-6 col-md-6 col-sm-12 form-group animated-section" data-animation="fadeInLeft" data-delay="100">
                        <input type="text" name="username" placeholder="Your Name" required />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 form-group animated-section" data-animation="fadeInRight" data-delay="100">
                        <input type="text" name="phone" required placeholder="Phone" />
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group animated-section" data-animation="fadeInUp" data-delay="200">
                        <input type="email" name="email" placeholder="Email Address" required />
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group animated-section" data-animation="fadeInUp" data-delay="300">
                        <div className="select-box">
                          <select className="wide">
                            <option data-display="I am parent looking course for my teen">I am parent looking course for my teen</option>
                            <option value="1">Driving Course</option>
                            <option value="2">Driving License</option>
                            <option value="3">Insurance</option>
                            <option value="4">Road Safety Guide</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group animated-section" data-animation="fadeInUp" data-delay="400">
                        <div className="select-box">
                          <select className="wide">
                            <option data-display="Extended Driving Course">Extended Driving Course</option>
                            <option value="1">Driving Course</option>
                            <option value="2">Driving License</option>
                            <option value="3">Insurance</option>
                            <option value="4">Road Safety Guide</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group animated-section" data-animation="fadeInUp" data-delay="500">
                        <textarea name="message" placeholder="Message"></textarea>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn animated-section" data-animation="fadeInUp" data-delay="600">
                        <button type="submit" className="theme-btn" name="submit-form">Read More</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="lower-box centred animated-section" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/shape/shape-38.png)` }} data-animation="fadeInUp" data-delay="700">
              <h5><a href="https://www.google.com/maps" target="_blank">Click here to view us on map</a></h5>
            </div>
          </div>
        </div>
      </section>

      <section className="location-style-two animated-section" data-animation="fadeInUp">
        <div className="shape">
          <div className="shape-1"></div>
          <div className="shape-2" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/shape/shape-82.png)` }}></div>
          <div className="shape-3 float-bob-x" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/shape/shape-73.png)` }}></div>
        </div>
        <div className="auto-container">
          <div className="sec-title centred animated-section" data-animation="zoomIn">
            <h2>List of our local branches</h2>
            <p>18 branches around the Unites States.</p>
          </div>
          <div className="row clearfix">
            <div className="col-lg-4 col-md-6 col-sm-12 location-block animated-section" data-animation="fadeInUp" data-delay="100">
              <div className="location-block-one">
                <div className="inner-box">
                  <h3>NY-Branch</h3>
                  <figure className="image-box"><img src={`${process.env.PUBLIC_URL}/assets/images/resource/location-1.jpg`} alt="" /></figure>
                  <div className="lower-content">
                    <div className="single-item">
                      <h6>Location</h6>
                      <p>880 Charles Building Lexington Avenue Newyork-87503.</p>
                    </div>
                    <div className="single-item">
                      <h6>Contact</h6>
                      <p><a href="tel:21288878901">212 888 78 901</a><br /><a href="mailto:info@udrivenewyork.com">info@udrivenewyork.com</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 location-block animated-section" data-animation="fadeInUp" data-delay="200">
              <div className="location-block-one">
                <div className="inner-box">
                  <h3>NY-Branch</h3>
                  <figure className="image-box"><img src={`${process.env.PUBLIC_URL}/assets/images/resource/location-1.jpg`} alt="" /></figure>
                  <div className="lower-content">
                    <div className="single-item">
                      <h6>Location</h6>
                      <p>880 Charles Building Lexington Avenue Newyork-87503.</p>
                    </div>
                    <div className="single-item">
                      <h6>Contact</h6>
                      <p><a href="tel:21288878901">212 888 78 901</a><br /><a href="mailto:info@udrivenewyork.com">info@udrivenewyork.com</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 location-block animated-section" data-animation="fadeInUp" data-delay="300">
              <div className="location-block-one">
                <div className="inner-box">
                  <h3>JAX-Branch</h3>
                  <figure className="image-box"><img src={`${process.env.PUBLIC_URL}/assets/images/resource/location-2.jpg`} alt="" /></figure>
                  <div className="lower-content">
                    <div className="single-item">
                      <h6>Location</h6>
                      <p>880 Charles Building Lexington Avenue Newyork-87503.</p>
                    </div>
                    <div className="single-item">
                      <h6>Contact</h6>
                      <p><a href="tel:21288878901">212 888 78 901</a><br /><a href="mailto:info@udrivenewyork.com">info@udrivenewyork.com</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
